<div class="app-skeleton" *ngIf="isLoading">
  <div class="skeleton-sidebar">
    <div class="sidebar-item" *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8]; trackBy: trackByIndex"></div>
  </div>
  <div class="skeleton-main">
    <div class="skeleton-header"></div>
    <div class="skeleton-content">
      <div class="content-row">
        <div class="skeleton-card" *ngFor="let i of [1, 2, 3]; trackBy: trackByIndex"></div>
      </div>
      <div class="skeleton-chart-area"></div>
      <div class="content-row">
        <div class="skeleton-card" *ngFor="let i of [1, 2, 3, 4]; trackBy: trackByIndex"></div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="!isLoading">
  <router-outlet></router-outlet>
</div>
